import React, { useEffect, useState, useRef } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import NoDataFound from "../../NoDataFound";
import { GROUP_TAB_TYPE, TABS_TYPE_KEY } from "../../../constant/constants";
import { useNavigate, useParams } from "react-router-dom";
import apiClient from "../../../apiClient";
import { APPLICATION_RESOURCE_COUNT, GROUP_SETTING } from "../../../apiClient/apiEndpoints";
import { checkPermissionExist, modalName, toggleArrayByObject } from "../../../utils/general";
import { useModalContext } from "../../../modal/context/ModalProvider";
import {
  GROUP_MOVE_PERMISSION,
  RESOURCE_REVOKE_PERMISSION,
  GROUP_CREATE_PERMISSION,
  GROUP_STATUS_PERMISSION,
  SUBGROUP_VIEW_PERMISSION,
} from "../../../constant/permission";
import { useScrollDirectionClass } from "../../ForMobile/useScrollDirectionClass";

const { GridView, GroupUserCard, PlaceholderCard, SimCheckBox, SimToggleSwitch } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const GroupTab = ({
  isMobileView,
  triggerRefreshHandler,
  hasMore,
  handleClearSelection,
  paginationPage,
  search,
  list,
  loading,
  handleChangeLocallyStatus,
  getSubGroupsList,
  selectedItems,
  setSelectedItems,
}) => {
  const { openModal } = useModalContext();
  const configData = useUnoSelector((state) => state.config);
  const params = useParams();
  const navigate = useNavigate();
  const [groupList, setGroupList] = useState([]);

  useEffect(() => {
    setGroupList(list);
  }, [list]);

  useScrollDirectionClass();

  const loadMoreData = () => {
    getSubGroupsList(paginationPage, search);
  };

  const handleChangeStatus = async (data) => {
    try {
      handleChangeLocallyStatus({ ids: [data.uuid], status: data.active });
      await apiClient.post(
        `${configData.config.UNO_URL}${GROUP_SETTING}/${TABS_TYPE_KEY[GROUP_TAB_TYPE]}/${data.uuid}`,
        {
          active: data.active,
        }
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectItems = (data) => {
    setSelectedItems((pre) => toggleArrayByObject(pre, data));
  };

  const handleAssignAppClick = (data) => {
    let selectedData = {
      type: GROUP_TAB_TYPE,
      items: [{ name: data.name, uuid: data.uuid, avatar: data.avatar }],
    };
    navigate(`/resource-management/${GROUP_TAB_TYPE}/${params.uuid}`, { state: { selectedData } });
  };

  const handleGroupClick = (uuid) => {
    if (checkPermissionExist(SUBGROUP_VIEW_PERMISSION)) {
      navigate(`/team-management/${uuid}`);
    }
  };

  const fetchAssignedResourceData = async (id) => {
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}${APPLICATION_RESOURCE_COUNT}/${id}`);
      let assignData = Object.fromEntries(Object.entries(data || []).map(([key, value]) => [key, value.length]));
      let _list = groupList.map((item) => ({
        ...item,
        assignedAppResource: item.uuid === id ? assignData : item.assignedAppResource,
      }));
      setGroupList([..._list]);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div id="scrollableDivGroups" className="scrollable-container">
        {loading ? (
          <PlaceholderCard circle={true} count={4} />
        ) : groupList.length > 0 ? (
          <InfiniteScroll
            scrollThreshold={0.7}
            dataLength={groupList.length}
            next={() => loadMoreData()}
            hasMore={hasMore}
            loader={<PlaceholderCard circle={true} count={4} />}
            scrollableTarget="scrollableDivGroups"
          >
            <div className="groups-tab">
              <GridView>
              {groupList.map((group, i) => {
                const UserDropdownItems = [
                  {
                    permission: RESOURCE_REVOKE_PERMISSION,
                    hide: isMobileView,
                    label: "Assign Application",
                    onClick: () => handleAssignAppClick(group),
                  },
                  {
                    permission: GROUP_CREATE_PERMISSION,
                    hide: !isMobileView,
                    label: "Edit",
                    onClick: () =>
                      openModal({
                        modalName: "GROUP_ADD",
                        type: "update",
                        id: group.uuid,
                        params,
                        handleRefreshTab: triggerRefreshHandler,
                      }),
                  },
                  {
                    permission: GROUP_STATUS_PERMISSION,
                    label: "Status",
                    hide: !isMobileView,
                    component: (
                      <SimToggleSwitch
                        checked={group.active}
                        onChange={() =>
                          handleChangeStatus({ type: GROUP_TAB_TYPE, active: !group.active, uuid: group.uuid })
                        }
                      />
                    ),
                  },
                  {
                    permission: GROUP_MOVE_PERMISSION,
                    label: "Move",
                    hide: isMobileView,
                    onClick: () =>
                      openModal({
                        modalName: modalName.GROUP_USER_MOVE,
                        params,
                        type: GROUP_TAB_TYPE,
                        transferData: [{ id: group.uuid, data: group }],
                        status: true,
                        handleRefreshTab: triggerRefreshHandler,
                        handleClearSelection,
                      }),
                  },
                ];

                let dropDowns = UserDropdownItems.filter((e) => !e.hide && checkPermissionExist(e.permission));

                return (
                  <GroupUserCard
                    key={i}
                    Name={group.name}
                    Tag={group.role}
                    subGroup={String(group.groups || 0)}
                    groupUsers={String(group.users || 0)}
                    assignedApps={String(group.assignedApps || 0)}
                    Image={group.avatar}
                    assignedAppResource={group?.assignedAppResource || null}
                    fetchAssignedResourceData={() => fetchAssignedResourceData(group.uuid)}
                    group_id={group.identifier}
                    cardTypeUser={false}
                    userDes={false}
                    userMail={false}
                    editButtonEnable={checkPermissionExist(GROUP_CREATE_PERMISSION)}
                    onEditClick={() =>
                      openModal({
                        modalName: "GROUP_ADD",
                        type: "update",
                        id: group.uuid,
                        params,
                        handleRefreshTab: triggerRefreshHandler,
                      })
                    }
                    onClick={() =>
                      selectedItems.length > 0
                        ? handleSelectItems({ id: group.uuid, data: group })
                        : handleGroupClick(group.uuid)
                    }
                    dropdownItems={dropDowns.length > 0 ? dropDowns : false}
                    checkbox={
                      !isMobileView ? (
                        <SimCheckBox
                          onChange={() => handleSelectItems({ id: group.uuid, data: group })}
                          checked={selectedItems.find((item) => item.id === group.uuid)}
                        />
                      ) : (
                        false
                      )
                    }
                    isActive={group.active}
                  />
                );
              })}
              </GridView>
            </div>
          </InfiniteScroll>
        ) : (
          <div className="no-data">
            <NoDataFound headText="No Group found" infoText="" />
          </div>
        )}
      </div>
    </>
  );
};

export default GroupTab;
